import { atomFamily } from "recoil";

import { RydeUiUnit } from "../../models";

export const tableSearchAF = atomFamily<string, RydeUiUnit>({
  key: "tableSearchAF",
  default: "",
});
